const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'SET_QUOTE':
      return { ...state, ...action.quote };
    case 'CLEAR_PLAN':
      return initialState;
    default:
      return state;
  }
}
